import React, { useContext, useState } from 'react'
import { memo } from 'react';
import { isMobile } from 'react-device-detect';
import { useQuery } from 'react-query';
import { askQuestionLV } from '../../core';
import { BotContext } from '../context';
import { QuestionContent } from '../pages/bot/QuestionContent'

const QuestionComponent = memo((props) => {
    const { buttonProps, selectedRoom, inputRef } = useContext(BotContext);
    const [buttonQuestion] = useState({
        questionquestion: buttonProps?.question,
        label_question: buttonProps?.label_question,
    });
    const [text] = useState(buttonProps?.question);
    const [label] = useState(buttonProps?.label_question);


    const message = props.message ?? buttonQuestion;
    useQuery(
        "askQuestionLV",
        async () => {
            const { data } = await askQuestionLV(text, label, selectedRoom?.name);
            return data;
        },
        {
            onSuccess() {
                !isMobile && inputRef.current.focus();
            },
            onError(error) {
                console.log(error);
            },
            refetchOnMount: true,
        }
    );
    return (
        <QuestionContent questionText={message?.label_question} />
    )
})

export { QuestionComponent }